import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { AppService } from '../../application/app.service';
import { LoginService } from '../../login/store/login.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreService } from '../store/core.service';
import { AppRoutingModule } from '../../app-routing.module';
import { AppBarComponent } from './header/appbar-container.component';
import { FooterComponent } from './footer/footer.component';

@Component({
  selector: 'ama-ng-layout',
  template: `
      <div class="df-app-container">
          @if ((loginService.loginPageDisplay$ | async) !== true) {
              <ama-ng-appbar [section]="(section$ | async)!"
                             [numberNewApps]="(appService.numberNewApps$ | async)!">
              </ama-ng-appbar>
          }
          <div class="df-scroll-content d-flex flex-column">
              <router-outlet></router-outlet>
              <ama-ng-footer class="mt-auto"></ama-ng-footer>
          </div>
      </div>`,
  imports: [
    AsyncPipe,
    AppRoutingModule,
    AppBarComponent,
    FooterComponent
  ],
  standalone: true
})
export class LayoutComponent {
  section$: Observable<string | null>;

  constructor(readonly loginService: LoginService,
              readonly appService: AppService,
              readonly coreService: CoreService) {
    this.section$ = this.coreService.navigation$
        .pipe(map(nav => {
              if (nav.navigationBlocked?.alert?.targetSection === undefined ||
                  Object.keys(nav.navigationBlocked?.alert).length === 0) {
                return nav.section;
              }
              return null;
            })
        );
  }
}